import { CloseSVG } from 'src/components/Icons/Basic'
import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const MenuContainer = styled.div<{
  isOpen: boolean
}>`
  position: absolute;
  border-radius: 16px;
  background-color: white;
  min-width: 200px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
`

export const MenuContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const MenuItemLink = styled.a<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  color: inherit;
  text-decoration: none;
  font-weight: ${({ isActive }) => (isActive ? 600 : 400)};
  color: ${({ isActive }) =>
    isActive ? palette.neutral[700] : palette.neutral[900]};
  transition: color 0.2s ease;
`

export const MenuItemContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 12px;
  color: ${palette.neutral[900]};

  &:hover {
    background-color: ${palette.neutral[500]};

    ${MenuItemLink} {
      color: white !important;
    }
  }
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${palette.neutral[50]};
`

export const TitleContainer = styled.div`
  padding: 16px;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const CloseIcon = styled(CloseSVG)`
  height: 16px;
  width: 16px;
  flex-shrink: 0;
  &:hover {
    cursor: pointer;
  }
`
